import React from 'react';
import cx from 'classnames';

// Components
import { ResponsiveImage } from '@shopee-user/shared-customization-ui';

// Constants
import { config } from '@shopee-user/platform';
import { Locale } from '@shopee-user/global';

// Assets
import logoMdpi from './logo-1x.png';
import logoHdpi from './logo-1.5x.png';
import logoXhdpi from './logo-2x.png';
import logoXxhdpi from './logo-3x.png';
import logoXxxhdpi from './logo-4x.png';
import logoInstantMdpi from './logo-instant-1x.png';
import logoInstantHdpi from './logo-instant-1.5x.png';
import logoInstantXhdpi from './logo-instant-2x.png';
import logoInstantXxhdpi from './logo-instant-3x.png';
import logoInstantXxxhdpi from './logo-instant-4x.png';

import { ResponsiveImageUseCase } from '@shopee-user/business-customization-types';

import styles from './style.scss';

export default function Logo({ className }: { className?: string }) {
  if (config.LOCALE === Locale.PH) {
    return (
      <ResponsiveImage
        usecase={ResponsiveImageUseCase.AuthLogo}
        className={cx(className, styles.logo)}
        defaultSrc={logoInstantXhdpi}
        srcSet={[
          { src: logoInstantMdpi, size: '1x' },
          { src: logoInstantHdpi, size: '1.5x' },
          { src: logoInstantXhdpi, size: '2x' },
          { src: logoInstantXxhdpi, size: '3x' },
          { src: logoInstantXxxhdpi, size: '4x' },
        ]}
      />
    );
  } else {
    return (
      <ResponsiveImage
        usecase={ResponsiveImageUseCase.AuthLogo}
        className={cx(className, styles.logo)}
        defaultSrc={logoXhdpi}
        srcSet={[
          { src: logoMdpi, size: '1x' },
          { src: logoHdpi, size: '1.5x' },
          { src: logoXhdpi, size: '2x' },
          { src: logoXxhdpi, size: '3x' },
          { src: logoXxxhdpi, size: '4x' },
        ]}
      />
    );
  }
}
